<script lang="ts" setup>
const props = defineProps<{
  maxProgress: number
  progress: number
}>()

const radius = 16.5
const circumference = 2 * Math.PI * radius

const circleOffset = computed(() => {
  const maxProgress = props.maxProgress
  const percentage = Math.min(props.progress / maxProgress, 1)

  return circumference * (1 - percentage)
})
</script>

<template>
  <div class="size-max">
    <div v-if="circleOffset !== 0" class="relative size-[42px] rotate-[270deg]">
      <svg class="-rotate-90" height="42" viewBox="0 0 42 42" width="42">
        <circle
          cx="21"
          cy="21"
          fill="transparent"
          r="16.5"
          stroke="#DDEBD8"
          stroke-dasharray="103.67"
          stroke-width="7"
        />

        <circle
          cx="21"
          cy="21"
          fill="transparent"
          r="16.5"
          stroke="#59ad3b"
          stroke-dasharray="103.67"
          :stroke-dashoffset="circleOffset"
          stroke-linecap="round"
          stroke-width="7"
          style="transition: stroke-dashoffset 0.3s ease, stroke 0.3s ease"
        />
      </svg>
    </div>
    <SvgIcon v-else class="!size-[42px]" name="outlined/success-rounded" />
  </div>
</template>
